import type { GraphQLResult } from 'aws-amplify/api'
import { useQuery } from '@tanstack/react-query'
import type { Shop } from '@skop-app/lib-types'
import { getAmplifyClient } from '@/services/amplifyClient'
import { shopFragment } from '@/services/fragments'
import type { ShopForTasks } from '@/features/shop/shop.types'
import { parseShareInfo } from '@/features/shop/settings/shopSettings.model'

const client = getAmplifyClient()

export const useShop = ({ id }) => {
  return useQuery({
    queryKey: ['shop', id],
    queryFn: async () => getShop(id),
    enabled: !!id,
  })
}

const getShop = async (id: string): Promise<ShopForTasks | null> => {
  try {
    const {
      data: { getShop: rawShop },
    } = (await client.graphql({
      query: /* GraphQL */ `
        query getShop($id: ID!) {
          getShop(id: $id) {
            ...shopData
          }
        }
        ${shopFragment}
      `,
      variables: { id },
    })) as GraphQLResult<{
      getShop: Shop
    }>

    if (!rawShop) {
      return null
    }

    const parsedShareInfo = parseShareInfo(rawShop.shareInfo)

    return {
      ...rawShop,
      shareInfo: parsedShareInfo,
    }
  } catch (e) {
    console.error(e)
    throw e
  }
}
